import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const routeTitleMap = {
  '/': 'Home',
  '/home': 'Home',
  '/preferences': 'Filter Preferences',
  '/files': 'Files',
  '/timeline': 'Timeline',
  '/dit': 'DIT',
  '/search': 'Search',
  '/upload': 'Upload',
  '/users': 'Users',
  '/devices': 'Devices',
  '/devices/user': 'My Devices',
  '/devices/user/pending': 'Pending Registrations',
  '/devices/admin': 'Device Admin',
  '/download': 'Download',
  '/preview': 'Preview',
  '/file-compare': 'File Compare',
  '/dbcombiner': 'Combiner',
  '/dbcombiner_task_status': 'Combiner Status',
  '/dtc_log': 'DTC Log',
  '/part_number_pull': 'Part Number Pull',
  '/test_result_ingestion': 'Test Result Ingestion',
  '/event': 'Event',
  '/vehicle_lookup': 'Vehicle Lookup',
  '/access-denied': 'Access Denied',
  '/bus_log': 'Bus Log Visualization',
};


export const useDocumentTitle = () => {
  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname;
    const pageName = pathname.startsWith('/wivi_inventory')
      ? 'Devices'
      : pathname.startsWith('/devices/') && pathname !== '/devices/user' && pathname !== '/devices/admin' && pathname !== '/devices/user/pending'
        ? 'Device Detail'
      : routeTitleMap[pathname] || 'SDL';
    document.title = `SDL - ${pageName}`;
  }, [location.pathname]);
};

